import { Loader } from "@/components/shared/loader";
import { ObsChartPicker } from "@/features/obs/components/ObsChartPicker";
import { useObsWizard } from "@/features/obs/hooks/obs-wizard-context";
import { dimHeadersFromMapping } from "@/features/obs/lib/chart-labels";

/** Step 5 — pick the charts, out of what this data can actually draw. */
export function StepCharts() {
  const { draft, patch, chartOptions } = useObsWizard();
  const { roles, enRoles } = draft;

  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-border bg-muted/30 p-3 text-sm text-muted-foreground">
        اختر الرسوم التي ستُعرض في هذا التقرير وترتيبها. تُقترح العناوين من أسماء
        الأعمدة التي أكّدتها، ويمكنك تعديلها.
      </div>

      {chartOptions.isLoading && (
        <p className="flex items-center gap-2 text-sm text-muted-foreground">
          <Loader /> جارٍ حساب الرسوم المتاحة لهذه البيانات…
        </p>
      )}

      {/* Labels, not headings. A workbook with no English column leaves every
          ministry and category name in Arabic on the English site — validate.ts
          warns about it, but that warning sits inside the validation report where
          it is easy to scroll past, and this is the last screen before
          publishing. */}
      {(["entity", "category", "type"] as const).some(
        (r) => roles[r] && !enRoles[r],
      ) && (
        <div className="rounded-lg border border-amber-500/40 bg-amber-500/5 p-3 text-sm">
          لا يحتوي الملف على أعمدة إنجليزية لبعض التسميات، لذا ستظهر أسماء الجهات
          أو التصنيفات بالعربية في النسخة الإنجليزية من الموقع. عناوين الرسوم
          أدناه لن تتأثر.
        </div>
      )}

      {chartOptions.data?.capabilities && (
        <ObsChartPicker
          options={chartOptions.data.options}
          capabilities={chartOptions.data.capabilities}
          headers={dimHeadersFromMapping(roles, enRoles)}
          charts={draft.charts}
          onChange={(charts) => patch({ charts })}
        />
      )}

      {chartOptions.data && !chartOptions.data.hasData && (
        <p className="text-sm text-red-600">
          لا توجد بيانات منشورة لهذا التقرير، فلا يمكن تحديد الرسوم المتاحة.
        </p>
      )}
    </div>
  );
}
